import { useReselector } from '@/utils/sharedHooks'
import { getCurrentUser } from '@/selectors/user.selectors'
import { useIsDeviceWidth, DeviceWidth } from '@/utils/deviceWidthHelpers'

import { selectCatchUpBookkeepingIsCompleteForUser } from '@/components/CatchUpBookkeepingStatus/catchUpBookkeepingStatus.selector'
import { selectHasUserCompletedOnboardingPhase } from '@/features/onboarding/user-onboarding-steps/onboarding.selectors'
import { OnboardingStepPhase } from '@/features/onboarding/user-onboarding-steps/onboarding.reducer'
import { CatchUpBookkeepingStatus } from './catch-up-bookkeeping/CatchUpBookkeepingStatus'
import { OnboardingItemList } from './getting-started-items/OnboardingItemList'
import { Image, Text } from '@/ui'
import { TextColors, TypographyStyles } from '@/styles'

export const GettingStarted = () => {
  const currentUser = useReselector(getCurrentUser)
  const isMobile = useIsDeviceWidth(DeviceWidth.mobile)
  const catchUpBKComplete = useReselector(
    selectCatchUpBookkeepingIsCompleteForUser,
    currentUser?.id
  )
  const gettingStartedPhaseComplete = useReselector(
    selectHasUserCompletedOnboardingPhase,
    OnboardingStepPhase.gettingStarted
  )
  const headerText = gettingStartedPhaseComplete
    ? 'Almost there'
    : 'Get Started with Heard'

  return (
    <>
      <div className="flex flex-row">
        <div className="w-2/3 flex flex-col gap-2 text-left justify-between pb-10 w-full">
          <Text variant={TypographyStyles.EYEBROW} color={TextColors.MOSS}>
            Welcome {currentUser?.firstName}!
          </Text>
          <Text variant={TypographyStyles.DISPLAY_LG}>{headerText}</Text>
          <Text variant={TypographyStyles.BODY_SM}>
            {!gettingStartedPhaseComplete ? (
              <>
                Let&apos;s get your account set up so we can help you grow and
                manage your therapy practice.
              </>
            ) : (
              gettingStartedPhaseComplete &&
              !catchUpBKComplete && (
                <>
                  Thanks for reviewing all of your getting started items. Our
                  bookkeeping team now has what they need to finish your
                  Catch-up Bookkeeping. We&apos;ll be working on this as fast as
                  possible and will reach out if we have any questions.
                </>
              )
            )}
          </Text>
          <CatchUpBookkeepingStatus />
        </div>
        <div className="w-1/3">
          {!isMobile && (
            <Image
              src="https://heard-images.s3.amazonaws.com/assets/ledger-and-coffee.svg"
              alt="Ledger and Coffee"
              objectFit="contain"
            />
          )}
        </div>
      </div>
      <OnboardingItemList />
    </>
  )
}
